export default "__VITE_PUBLIC_ASSET__fbb36e3b__"